module.exports = __webpack_public_path__ + "images/top_icon_search_black.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/top_icon_search_black.png
// module id = 904
// module chunks = 124